'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createSocket = createSocket;
exports.subscribe = subscribe;
exports.socketNotifier = socketNotifier;

var _immutable = require('immutable');

var _socket = require('socket.io-client');

var _socket2 = _interopRequireDefault(_socket);

var _notifiers = require('./notifiers');

var _notifiers2 = _interopRequireDefault(_notifiers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/*
 * CREATE SOCKET
 *
 * Create a connection to the server for server-side events.
 * the socketOptions passed to io should contain at least a 'path' property
 */
function createSocket(_ref) {
  var _ref$uri = _ref.uri,
      uri = _ref$uri === undefined ? undefined : _ref$uri,
      _ref$onCreate = _ref.onCreate,
      onCreate = _ref$onCreate === undefined ? undefined : _ref$onCreate,
      _ref$onConnect = _ref.onConnect,
      onConnect = _ref$onConnect === undefined ? undefined : _ref$onConnect,
      _ref$onHandshake = _ref.onHandshake,
      onHandshake = _ref$onHandshake === undefined ? undefined : _ref$onHandshake,
      _ref$onDisconnect = _ref.onDisconnect,
      onDisconnect = _ref$onDisconnect === undefined ? undefined : _ref$onDisconnect,
      socketOptions = _objectWithoutProperties(_ref, ['uri', 'onCreate', 'onConnect', 'onHandshake', 'onDisconnect']);

  var socket = void 0;
  if (uri) {
    socket = (0, _socket2.default)(uri, _extends({}, socketOptions));
  } else {
    socket = (0, _socket2.default)(_extends({}, socketOptions));
  }
  if (onCreate) {
    onCreate(socket);
  }
  _addSocketEvents(socket, { onConnect: onConnect, onHandshake: onHandshake, onDisconnect: onDisconnect });
  return socket;
}

// Tracking of all subscriptions for funneling multiple local subscriptions into a single remote subscription, and
// for enabling re-subscription when disconnects occur.
var _subscriptions = (0, _immutable.Map)();

/*
 * Add a channel, unique id, and callback to the global tracking list.  Optionally, a callback can be made when
 * the first id is add to a new channel.
 */
function addSubscription(channel, id, callback) {
  var onFirst = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

  // Subscribe to the channel and emit a subscribe action to the server if it's the first time this subscription
  // has happened.
  var channelSubscriptions = _subscriptions.get(channel);
  if (channelSubscriptions === undefined) {
    // Subscribe to the channel
    channelSubscriptions = (0, _immutable.Map)();
    channelSubscriptions = channelSubscriptions.set(id, callback); // Purposely done after to keep type of id
    _subscriptions = _subscriptions.set(channel, channelSubscriptions);
    if (onFirst !== undefined) {
      onFirst();
    }
  } else {
    _subscriptions = _subscriptions.setIn([channel, id], callback);
  }
}

/*
 * Remove a unique id from the global tracking list for a given channel.  Optionally, a callback can be made when
 * the last id is removed from the given channel.
 */
function removeSubscription(channel, id) {
  var onLast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  var channelSubscriptions = _subscriptions.get(channel);
  if (channelSubscriptions !== undefined) {
    // Remove the tag from the channel
    channelSubscriptions = channelSubscriptions.delete(id);
    if (channelSubscriptions.isEmpty()) {
      // No more subscribers to this channel.  Unsubscribe from the server.
      _subscriptions = _subscriptions.delete(channel);
      if (onLast !== undefined) {
        onLast();
      }
    } else {
      // There is still at least 1 subscriber.  Just update the tracking list.
      _subscriptions = _subscriptions.set(channel, channelSubscriptions);
    }
  }
}

/*
 * SUBSCRIBE
 *
 * Subscribe to a given channel on a socket.  To unsubscribe use the function returned from this function.
 */
function subscribe(socketNotifier, subscribeId, channel, callback) {
  // Wrap the callback to make it a unique function instance.  This is a protection mechanism that prevents two
  // subscriptions from different instances using a common function from interfering with each other.
  var uniqueCallback = function uniqueCallback() {
    return callback.apply(undefined, arguments);
  };

  var onFirst = undefined;
  if (socketNotifier.socket !== null) {
    // Add the callback to the channel and save the unsubscribe.
    socketNotifier.socket.on(channel, uniqueCallback);
    onFirst = function onFirst() {
      return socketNotifier.socket.emit('subscribe', { channel: channel });
    };
  }

  addSubscription(channel, subscribeId, uniqueCallback, onFirst);

  // Return the unsubscribe function
  return function unsubscribe() {
    var onLast = undefined;
    if (socketNotifier.socket !== null) {
      // Remove the internal callback subscription from Socket.io
      //noinspection JSUnresolvedFunction
      socketNotifier.socket.removeListener(channel, uniqueCallback);

      onLast = function onLast() {
        return socketNotifier.socket.emit('unsubscribe', { channel: channel });
      };
    }

    // Remove the subscription
    removeSubscription(channel, subscribeId, onLast);
  };
}

/*
 * RECONNECT SUBSCRIPTIONS
 *
 * Reconnect all subscriptions and re-make all callbacks after a disconnect
 */
function reconnectSubscriptions(socket) {
  _subscriptions.forEach(function (channelSubscriptions, channel) {
    socket.emit('subscribe', { 'channel': channel });
    channelSubscriptions.forEach(function (callback) {
      callback();
    });
  });
}

/*
 * ADD SOCKET EVENTS
 *
 * Listen to all server-side events
 */
function _addSocketEvents(socket, _ref2) {
  var _ref2$onConnect = _ref2.onConnect,
      onConnect = _ref2$onConnect === undefined ? undefined : _ref2$onConnect,
      _ref2$onHandshake = _ref2.onHandshake,
      onHandshake = _ref2$onHandshake === undefined ? undefined : _ref2$onHandshake,
      _ref2$onDisconnect = _ref2.onDisconnect,
      onDisconnect = _ref2$onDisconnect === undefined ? undefined : _ref2$onDisconnect;


  // Subscribe the store to the connected status events and reconnect any subscribed channels if required.
  socket.on('connect', function () {
    if (!!onConnect) {
      onConnect(socket);
    }
    reconnectSubscriptions(socket);
  });

  socket.on('handshake', function (data) {
    if (!!onHandshake) {
      onHandshake(data);
    }
  });

  socket.on('disconnect', function () {
    if (!!onDisconnect) {
      onDisconnect();
    }
  });
}

var SocketNotifier = function (_Notifier) {
  _inherits(SocketNotifier, _Notifier);

  function SocketNotifier() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref3$requiresAuthent = _ref3.requiresAuthentication,
        requiresAuthentication = _ref3$requiresAuthent === undefined ? false : _ref3$requiresAuthent,
        socketOptions = _objectWithoutProperties(_ref3, ['requiresAuthentication']);

    _classCallCheck(this, SocketNotifier);

    var _this = _possibleConstructorReturn(this, (SocketNotifier.__proto__ || Object.getPrototypeOf(SocketNotifier)).call(this));

    _this.requiresAuthentication = requiresAuthentication;
    _this.socketOptions = socketOptions;
    _this.socket = null;
    return _this;
  }

  _createClass(SocketNotifier, [{
    key: 'onStart',
    value: function onStart() {
      var extraSocketOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.socket = createSocket(_extends({}, this.socketOptions, extraSocketOptions));
    }
  }, {
    key: 'onStop',
    value: function onStop() {
      this.socket = null;
    }
  }, {
    key: 'onLogin',
    value: function onLogin(authenticationPayload) {
      if (this.requiresAuthentication) {
        this.onStart({
          query: {
            auth_type: authenticationPayload.type,
            auth_token: authenticationPayload.token
          }
        });
      }
    }
  }, {
    key: 'onLogout',
    value: function onLogout() {
      if (this.requiresAuthentication) {
        this.onStop();
      }
    }
  }, {
    key: 'onSubscribe',
    value: function onSubscribe(subscribeId, channel, onNotify) {
      return subscribe(this, subscribeId, channel, onNotify);
    }
  }]);

  return SocketNotifier;
}(_notifiers2.default);

function socketNotifier() {
  var socketOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return new SocketNotifier(socketOptions);
}